import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const RequestedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 76 18", ...rest } = props;

    return (
        <svg
            data-cy="requestedBadge"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
        >
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g>
                    <rect
                        width="76"
                        height="17.69"
                        x="0"
                        y="0"
                        fill="#54D2C7"
                        rx="1.966"
                    ></rect>
                    <path
                        fill="#210071"
                        fillRule="nonzero"
                        d="M7.28 12.966V9.424h.726c.167 0 .34-.006.496-.006l2.044 3.548h1.417L9.699 9.292c.968-.294 1.636-1.06 1.636-2.114 0-1.497-1.244-2.35-2.782-2.35h-2.51v8.138H7.28zM8.664 8.41h-1.37V5.94h1.272c.956 0 1.543.483 1.543 1.26 0 .732-.53 1.18-1.445 1.21zm10.054 4.555v-1.17h-4.146V9.46h3.812v-1.14h-3.812v-2.35h4.146v-1.14h-5.384v8.137h5.384zm8.483.622l.8-.755-1.163-1.111c.553-.732.846-1.745.846-2.816 0-2.217-1.22-4.187-3.864-4.187-2.637 0-3.858 1.958-3.858 4.175 0 2.217 1.221 4.181 3.858 4.181.887 0 1.63-.236 2.218-.65l1.163 1.163zm-3.38-1.682c-1.838 0-2.62-1.365-2.62-3.012 0-1.64.782-3.006 2.62-3.006 1.848 0 2.625 1.365 2.625 3.006 0 .737-.155 1.382-.506 1.93l-1.17-1.106-.806.737 1.192 1.111c-.34.208-.788.34-1.336.34zm8.655 1.169c2.107 0 3.052-1.267 3.052-3.3V4.83h-1.238v4.854c0 1.405-.444 2.194-1.814 2.194-1.365 0-1.803-.783-1.803-2.182V4.829h-1.238v5.004c0 1.98.933 3.242 3.04 3.242zm10.51-.11v-1.168h-4.147V9.459h3.812v-1.14h-3.812v-2.35h4.146v-1.14H37.6v8.137h5.384zm4.088.087c1.531 0 2.764-.927 2.764-2.413 0-2.695-4.02-2.125-4.02-3.795 0-.599.507-1.025 1.175-1.025.616 0 1.117.323 1.434.922l1.025-.634c-.541-.962-1.417-1.388-2.419-1.388-1.336 0-2.453.806-2.453 2.189 0 2.614 4.02 2.004 4.02 3.84 0 .68-.553 1.204-1.503 1.204-.939 0-1.688-.495-1.814-1.549l-1.227.311c.254 1.55 1.595 2.338 3.018 2.338zm7.25-.086V5.94h2.643V4.83h-6.53V5.94h2.649v7.026h1.238zm9.357 0v-1.17h-4.146V9.46h3.812v-1.14h-3.812v-2.35h4.146v-1.14h-5.384v8.137h5.384zm4.135 0c2.718 0 4.221-1.469 4.221-4.008 0-2.644-1.463-4.13-4.21-4.13h-2.303v8.138h2.292zm-.115-1.14h-.939V5.968h1.048c2.096 0 2.99.892 2.99 2.937 0 2.107-1.181 2.92-3.1 2.92z"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
